module.exports = __webpack_public_path__ + "static/media/empty-list-truck.a4ebf4de.png";